import { markRaw } from 'vue'

import { useWishlistItem as useBaseWishlistItem } from '@shared/fondof-fn/composables/wishlist'

import { HeartRedIcon, TrashCanIcon, WavehandIcon } from '@fond-of/satch-icons'

export const useWishlistItem = (id: string) =>
  useBaseWishlistItem(id, {
    icons: {
      trashCan: markRaw(TrashCanIcon),
      heartRed: markRaw(HeartRedIcon),
      wavehand: markRaw(WavehandIcon),
    },
  })
